import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import {
  brandOverride,
  getPoolMasterClass,
  isSupportTechnique,
} from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import convertSecondsToTime, {
  convertMinutesToTime,
} from '../../../../../../helper/convertSecondsToTime';
import { getTemperature } from '../../../../../../helper/temperature';
import { transformHourToDayHour } from '../../../../../../helper/horloge';
import { P0003600EtatHorsGelEnum } from '../../../Enum/P0003600EtatHorsGelEnum';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { DisplayRubriqueStatusWithWarningAndCtaComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning-and-cta/display-rubrique-status-with-warning-and-cta.component';

@Component({
  selector: 'app-p0003600-filtration-statut',
  templateUrl: './p0003600-filtration-statut.component.html',
  styleUrls: ['./p0003600-filtration-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    TranslatePipe,
    CollapseComponent,
    DisplayRubriqueStatusWithWarningAndCtaComponent,
  ],
})
export class P0003600FiltrationStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  transformHourToDayHourLocal(value: number): string {
    return transformHourToDayHour(value, this.translateService);
  }

  editValue(index: any, key: string, value: any): void {
    this.actionStack!.editValue(index, key, value);
  }

  commit(): void {
    this.actionStack!.commit();
  }

  resetProtectionMagnetique(): void {
    this.editValue(
      P00039DataRxTxIndex.FiltrationStandard_Controle,
      'fsCResetManuelProtectionMagnetique',
      1,
    );
    this.commit();
  }

  resetProtectionThermique(): void {
    this.editValue(
      P00039DataRxTxIndex.FiltrationStandard_Controle,
      'fsCResetManuelProtectionThermique',
      1,
    );
    this.commit();
  }

  get presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  protected readonly convertSecondsToTime = convertSecondsToTime;
  protected readonly convertMinutesToTime = convertMinutesToTime;
  protected readonly getTemperature = getTemperature;
  protected readonly transformHourToDayHour = transformHourToDayHour;
  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly P0003600EtatHorsGelEnum = P0003600EtatHorsGelEnum;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly brandOverride = brandOverride;
}
